 // app/javascript/dashboard/routes/dashboard/single_tenant/single-tenant.routes.js
import { frontendURL } from '../../../helper/URLHelper';
export const routes = [
  {
    path: frontendURL('accounts/:accountId/single-tenant'),
    name: 'single_tenant',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: () => import('./Index.vue'),
  },
];
export default { routes };
